<template>
  <div
    class="text-sm rounded-2xl rounded-tl-sm px-4 py-3 flex items-start gap-2"
    style="background: #fef2f2; border: 1px solid rgba(239,68,68,0.25); color: #991b1b;"
  >
    <svg
      class="w-4 h-4 mt-0.5 shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
    <div class="flex-1 min-w-0">
      <div>{{ error.message }}</div>

      <details v-if="hasRaw" class="mt-2 text-xs">
        <summary class="cursor-pointer select-none text-red-700/80 hover:text-red-700">
          Show technical details
        </summary>
        <dl class="mt-1.5 space-y-1 font-mono text-[11px] leading-snug text-red-900/85">
          <div v-if="error.code"><dt class="inline text-red-700/70">code:</dt> {{ error.code }}</div>
          <div v-if="error.raw?.status_code != null"><dt class="inline text-red-700/70">status:</dt> {{ error.raw.status_code }}</div>
          <div v-if="error.raw?.error_type"><dt class="inline text-red-700/70">type:</dt> {{ error.raw.error_type }}</div>
          <div v-if="error.raw?.error_message" class="break-words"><dt class="inline text-red-700/70">message:</dt> {{ error.raw.error_message }}</div>
          <div v-if="error.raw?.inner_type"><dt class="inline text-red-700/70">inner_type:</dt> {{ error.raw.inner_type }}</div>
          <div v-if="error.raw?.inner_message" class="break-words"><dt class="inline text-red-700/70">inner_message:</dt> {{ error.raw.inner_message }}</div>
          <div v-if="error.raw?.response_content">
            <dt class="text-red-700/70">response:</dt>
            <pre class="whitespace-pre-wrap break-all bg-red-100/60 rounded px-2 py-1 mt-0.5 max-h-40 overflow-auto">{{ error.raw.response_content }}</pre>
          </div>
        </dl>
      </details>

      <div v-if="error.retryable && canRetry" class="mt-2">
        <button
          type="button"
          class="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg transition-all hover:opacity-90 active:scale-95"
          style="background: #b91c1c; color: white;"
          :disabled="busy"
          @click="$emit('retry')"
        >
          <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Retry
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { AiProviderError } from '@/types/ai/cleoChat';

const props = defineProps<{
  error: AiProviderError;
  canRetry?: boolean;
  busy?: boolean;
}>();

defineEmits<{
  (e: 'retry'): void;
}>();

const hasRaw = computed(() => {
  const r = props.error.raw;
  if (!r) return false;
  return Boolean(
    r.error_type || r.error_message || r.status_code != null ||
    r.response_content || r.inner_type || r.inner_message,
  );
});
</script>
